export default __webpack_public_path__ + "static/media/assignment_success.2568effd.svg";